import React from "react";

const Toggle = ({ enabled, onChange }) => {
	return (
		<div
			style={{
				...styles.toggleContainer,
				backgroundColor: enabled ? "#ffffff" : "#6b7280",
			}}
			onClick={onChange}>
			<div
				style={{
					...styles.toggleThumb,
					backgroundColor: enabled ? "#4D63AC" : "white",
					transform: enabled ? "translateX(20px)" : "translateX(2px)",
				}}
			/>
		</div>
	);
};

const ConnectCalendarButton = ({ type, isConnected, onClick, calendarAccessGranted }) => {
	const getConnectionStatus = () => {
		if (isConnected) {
			if (!calendarAccessGranted) {
				return (
					<div style={styles.warningContainer}>
						<span style={styles.warningIcon}>⚠️</span>
						<span style={styles.warningText}>Needs calendar access</span>
					</div>
				);
			}
			return null; // Connected state handled by toggle
		}
		return null; // Not connected state handled by connect button
	};

	const getServiceIcon = () => {
		if (type === "microsoft") {
			return (
				<div style={styles.microsoftIcon}>
					<img src="./outlook.svg" alt="Outlook" style={styles.iconImageOutlook} />
				</div>
			);
		}
		return (
			<div style={styles.googleIcon}>
				<img src="./google.svg" alt="Google Calendar" style={styles.iconImage} />
			</div>
		);
	};

	// Show warning status only if connected but no access
	const showWarning = isConnected && !calendarAccessGranted;

	return (
		<div style={styles.serviceCard}>
			<div style={styles.serviceHeader}>
				<div style={styles.serviceInfo}>
					<div style={styles.serviceIcon}>
						{getServiceIcon()}
						<div style={styles.serviceTextContainer}>
							<span style={styles.serviceText}>{type === "microsoft" ? "Microsoft Calendar" : "Google Calendar"}</span>
							{showWarning && getConnectionStatus()}
						</div>
					</div>
				</div>
				<div style={styles.serviceActions}>
					{isConnected && calendarAccessGranted ? (
						<Toggle enabled={true} onChange={onClick} />
					) : isConnected && !calendarAccessGranted ? (
						<button style={styles.connectButton} onClick={onClick}>
							Grant Access
						</button>
					) : (
						<button style={styles.connectButton} onClick={onClick}>
							Connect
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

const styles = {
	serviceCard: {
		background: "transparent",
		borderRadius: "12px",
		padding: "1rem",
		border: "1px solid rgba(255, 255, 255, 0.2)",
		marginBottom: "1rem",
	},

	serviceHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		minHeight: "40px", // Add minimum height to ensure proper alignment
	},

	serviceInfo: {
		flex: 1,
		display: "flex",
		flexDirection: "column", // Stack vertically
		justifyContent: "center",
	},

	serviceIcon: {
		display: "flex",
		alignItems: "center",
		gap: "0.75rem",
		marginBottom: "0.25rem", // Small margin between icon/title and warning
	},

	googleIcon: {
		width: "32px",
		height: "32px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		overflow: "hidden",
	},

	microsoftIcon: {
		width: "32px",
		height: "32px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		overflow: "hidden",
	},

	iconImage: {
		width: "24px",
		height: "24px",
		objectFit: "contain",
	},
	iconImageOutlook: {
		width: "30px",
		height: "30px",
		objectFit: "contain",
	},

	serviceText: {
		fontSize: "14px",
		fontWeight: "600",
		color: "white",
	},

	serviceSubtext: {
		fontSize: "0.875rem",
		color: "rgba(255, 255, 255, 0.7)",
		minHeight: "1.2rem",
		fontWeight: "400",
		letterSpacing: "0.025em",
		lineHeight: "1.25",
		marginTop: "2px",
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
	},

	serviceActions: {
		display: "flex",
		alignItems: "center",
		gap: "0.75rem",
	},

	toggleContainer: {
		width: "44px",
		height: "24px",
		borderRadius: "12px",
		position: "relative",
		cursor: "pointer",
		transition: "background-color 0.2s ease",
	},

	toggleThumb: {
		width: "20px",
		height: "20px",
		borderRadius: "50%",
		position: "absolute",
		top: "2px",
		transition: "transform 0.2s ease, background-color 0.2s ease",
	},

	connectButton: {
		padding: "0.5rem 1rem",
		borderRadius: "6px",
		border: "none",
		background: "#ffffff",
		color: "#465C9E",
		fontSize: "0.875rem",
		cursor: "pointer",
		fontFamily: "inherit",
		fontWeight: "600",
		transition: "all 0.2s ease",
		":hover": {
			background: "#f9fafb",
		},
	},

	warningContainer: {
		display: "flex",
		alignItems: "center",
		gap: "0.5rem",
		color: "#fbbf24",
		fontSize: "0.75rem",
		marginTop: "0.1rem",
	},

	warningIcon: {
		fontSize: "0.75rem",
	},

	warningText: {
		fontSize: "0.75rem",
		color: "#fbbf24",
	},
};

export default ConnectCalendarButton;
